import { PersonsVersionsService_personVersionServiceGetLatest } from '@festina/legalentity-general-types/legalentity/hooks/PersonsVersionsService_personVersionServiceGetLatest'

export const useLazyFetchPersonVersionLatest =
  PersonsVersionsService_personVersionServiceGetLatest.useLazyQuery
